import makeBulkContext from './makeBulkContext';

export const { Provider: BulkApproveContextProvider, useContext: useBulkApproveContext } = makeBulkContext();
